module.exports = "/static/assets/39c019b1c9a3e8f30e35c6e601519af2.png";